export default "/images/854e00b3ed24cb273e7bfec87df2a5c2.avif";